export default {
  App: {
    title: '情報の相互接続、meから開く'
  },
  // views/logic/homePage/index.vue
  loigcHomePageIndex: {
    // 申请试用联系我们的两个小模块
    applyForTrial: '試用申請',
    contactUs: '連絡先',
    // 轮播图下方显示的4个小模块
    pictureSuspensionTitle1: '高速カスタムインタフェース',
    pictureSuspensionData1: '既存のシステムを変更することなく、対外開放の連結を実現するために、対外インタフェースを迅速に自己構築する',
    pictureSuspensionTitle2: 'マルチデータ仕様の統合',
    pictureSuspensionData2: 'データプラットフォーム間の仕様差異を解消し、データ仕様の統一を実現し、効率的で秩序ある',
    pictureSuspensionTitle3: 'マルチプラットフォーム情報相互接続',
    pictureSuspensionData3: 'インタフェースの能動的または受動的な呼び出し方式を通じて、プラットフォーム障壁を開き、情報の相互接続を実現する',
    pictureSuspensionTitle4: '情報がつながっていて、通則は痛くありません',
    pictureSuspensionData4: '企業システム間の相互作用効率を高め、情報を効率的に流動させ、問題点を減らし、痛みを解消する',
    // 热门应用
    popularApplicationsTitle: '安全で信頼性の高い革新的な製品とサービス',
    popularApplicationsButton: '試用申請',
    //解决方案
    successSwitchTitle: '推奨ソリューション',
    successSwitchButtonText: 'すべてのシナリオの表示',
    // 解决方案第一部分
    bankEnterpriseInterconnection: {
      label: '銀企業の相互接続',
      title1: 'セキュアなシルバー企業向けダイレクトソリューション',
      data1: '顧客の財務専用コンピュータにインストールされたクライアント、定期的にミドルウェアサービスを巡回し、業務システムの支払いなどの命令を取得し、事前にパスワードを復号し、対応する銀行操作を実行することにより、業務と銀行の直接接続効果を達成する。この方案にはセキュリティ上の危険性はなく、命令は転送中に全過程暗号化され、クライアントはイントラネットコンピュータにインストールされ、イントラネット露出のリスクはない。命令実行結果は定期的に業務システムにフィードバックされ、全過程が記録され、調査可能な根拠がある。',
      title2: '対応銀行',
      buttonText: '試用申請',
    },
    // 解决方案第二部分
    systemInterconnection: {
      label: 'OAシステム相互接続ソリューション',
      title1: 'OAシステム相互接続ソリューション',
      data1: 'ミドルウェアを通じて、複数のOAシステムと業務システムのインタフェースを通じて、複数のOAシステムの一連のインタフェースの相互接続を実現する。',
      title2: '対応OAシステム',
      dingding: 'くぎを打つ',
      feishu: '飛書',
      qiyeweixin: '企業のウィーチャット',
      buttonText: '試用申請'
    },
    // 解决方案第三部分
    controlSystemInterconnection: {
      label: '料金制御システムの相互接続',
      title1: '料金管理システムの相互接続ソリューション',
      data1: 'ミドルウェアを通じて、複数の費用管理制御システムと業務システムのインタフェースを通じて、複数の費用管理制御システムのインタフェースセットの相互接続を実現する。',
      title2: '対応費制御システム',
      buttonText: '試用申請'
    },
    // 成功客户
    focusOnCustomers: {
      title: 'お客様の成功に注目',
      buttonText: '詳細を表示',
    },
    // 最下方备注
    fonterTitle: 'Copyright©2022雲科同創（武漢）情報科学技術有限公司',
    // JS
    rules: {
      phoneCannotNull: '携帯番号を空にすることはできません',
      inputSuccessPhone: '正しい携帯番号を入力してください',
      inputSuccessEmail: 'メールアドレスを正しく記入してください',
      inputEffectiveEmail: '有効なメールボックスを入力してください',
      nameRule: '名前を入力してください',
      emailRule: 'メールアドレスを入力してください',
      phoneRule: '携帯番号を入力してください'
    },
    // 热门应用
    popularApplicationsList: {
      data1: {
        title: 'OAシステム',
        data1: {
          title: '企業のウィーチャットダイレクト',
          smallTitle: '企業のウィーチャットのOAなどの機能と業務システムの統合応用',
          data: ' 企業の微信におけるOA関連の帳票と業務システムをシームレスに接続し、携帯電話のモバイル端末の便利な機能を利用するだけでなく、業務システムとの通信も可能で、Anytime、Anywhere、Anydevice情報の随伴を実現する。 '
        },
        data2: {
          title: 'くぎの直接接続',
          smallTitle: 'ピンの承認機能とビジネスシステムの統合アプリケーション',
          data: ' 釘の強力な承認機能とビジネスシステムをシームレスに接続。 '
        },
        data3: {
          title: '飛書直結',
          smallTitle: 'フライブックのOAなどの機能と業務システムの統合応用',
          data: ' 飛書内のOA関連の帳票と業務システムをシームレスに接続し、携帯電話のモバイル端末の便利な機能を利用するだけでなく、業務システムとの通信も可能で、Anytime、Anywhere、Anydevice情報の随伴を実現する。 '
        },
        data4: {
          title: 'Lark Direct',
          smallTitle: '海外飛書LarkのOAなどの機能と業務システムの統合応用',
          data: ' 海外版飛書LarkにおけるOA関連の帳票と業務システムをシームレスに接続し、携帯電話のモバイル端末の便利な機能を利用するとともに、業務システムとの通信を可能にし、Anytime、Anywhere、Anydevice情報随伴を実現する。 '
        }
      },
      data2: {
        title: 'ひようシステム',
        data1: {
          title: '速報しやすい',
          smallTitle: '容易な速報とビジネスシステムの統合アプリケーション',
          data: ' 費用精算システムの簡単な速報と業務システムの統合応用。このアプリケーションは、構成可能でメンテナンスが容易なビジネスシステム向けの統合インタフェースを提供します。'
        },
        data2: {
          title: 'トランスファ',
          smallTitle: '連結容易性と業務システムの統合応用',
          data: ' 費用精算システムの易匯連結易と業務システムの統合応用。このアプリケーションは、構成可能でメンテナンスが容易なビジネスシステム向けの統合インタフェースを提供します。 '
        }
      },
      data3: {
        title: 'OMS',
        data1: {
          title: 'かんいうん',
          smallTitle: '管理クラウドOMSとビジネスシステムを直接接続するアプリケーション',
          data: ' 管理クラウドOMSとビジネスシステムを直接接続するアプリケーション。業務システムに向けて、業務文書の統一インタフェースを提供し、このインタフェースは配置でき、メンテナンスしやすい。 '
        },
        data2: {
          title: '易倉',
          smallTitle: '倉庫OMSとビジネスシステムを直接接続するアプリケーション',
          data: ' 倉庫OMSとビジネスシステムを直接接続するアプリケーション。業務システムに向けて、業務文書の統一インタフェースを提供し、このインタフェースは配置でき、メンテナンスしやすい。 '
        }
      },
      data4: {
        title: '電子商取引プラットフォーム'
      }
    },
    // 轮播图上显示的信息
    lunboImage1: {
      topLeftData: '相互交換',
      topRightData: 'インテリジェントデータ',
      h1Data: '企業の任督二脈を通じて、データの迅速な流通を実現する',
      pData: '企業がシステム間の情報障壁を迅速に開通させ、異なるシステム間の高速相互接続とデータ交換、安定した高効率処理と分析を実現することを支援する'
    },
    lunboImage2: {
      topLeftData: '仕様順序',
      topRightData: 'インテリジェントデータ',
      h1Data: 'データ仕様を統一し、データ仕様の秩序化を実現する',
      pData: '企業がデータインタフェースの規範を統一することを助け、データの来と去をさせ、整然として、企業運営データの各ノードを効率的に整列させ、安定した高効率処理と分析させる'
    },
  },
  // views/logic/contanctUs/index.vue 联系我们页面
  loigcContactUsIndex: {
    title: '連絡先',
    showData: 'プリセールスチームは、プリセールスコンサルティング、製品およびソリューションの推奨、構成の推奨などのサービスを提供し、相互接続を開始し、情報をスムーズにするのに役立ちます！',
    formName: '名前',
    formEmail: 'E-mail',
    formCorporateName: '会社名',
    formPosition: 'ポジション',
    formPhone: '携帯番号',
    formTextArea: '問い合わせ内容',
    buttonSubmit: '送信',
    // 下方备注
    fonterTitle: 'Copyright©2022雲科同創（武漢）情報科学技術有限公司',
    // JS
    subject: 'クラウド直結-製品-問い合わせ先-メール',
    sendSuccessTip: '送信成功',
  },
  // components/topBar/index.vue
  baseSwiperIndex: {
    connectUsTitle: '連絡先',
    register: '登録',
    welcomeWord: 'こんにちは',
    // JS
    showCenterDataList1: 'シーンを適用',
    showCenterDataList2: '人気のあるアプリケーション',
    showCenterDataList3: 'ソリューション',
    showCenterDataList4: '成功した顧客',
    console: 'コンソール',
    signOut: '終了',
    login: 'ログイン＃ログイン＃'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ja.js